import React, { Component } from 'react';
import ItemsList from '../containers/itemsList';
import ItemDetails, { Field } from '../containers/itemDetails';
import ErrorMessage from '../components/errorMessage';
import withGoTService from '../hoc/withGoTService';
import RowBlock from '../hoc/rowBlock';
import Layout from '../hoc/layout';
import { CHARACTERS } from '../utils/constants';
import { object } from 'prop-types';

class CharacterPage extends Component {
  static propTypes = {
    gotService: object,
  }

  state = {
    selectedChar: null,
    error: false,
  }

  onItemSelected = id => {
    this.setState({ selectedChar: id })
  }

  componentDidCatch() {
    this.setState({ error: true })
  }

  render() {
    const { selectedChar, error } = this.state
    const { gotService } = this.props

    if (error) {
      return <ErrorMessage />
    }

    const itemList = (
      <ItemsList
        onItemSelected={this.onItemSelected}
        id={selectedChar}
        getData={gotService.getAllItems.bind(null, CHARACTERS)}
        renderItem={({ name, gender }) => `${name} (${gender})`}
      />
    )

    const charDetails = (
      <ItemDetails
        itemId={selectedChar}
        itemType={CHARACTERS}
      >
        <Field field='gender' label='Gender' />
        <Field field='born' label='Born' />
        <Field field='died' label='Died' />
        <Field field='culture' label='Culture' />
      </ItemDetails>
    )

    return (
      <Layout>
        <RowBlock left={itemList} right={charDetails} />
      </Layout>
    )
  }
}

export default withGoTService()(CharacterPage)